export const MinutesToHours = (minutes) =>{
    let mins = minutes % 1440;
    let h = Math.floor(mins / 60);
    let m = mins % 60;
    let s = (h >= 12)? 'PM' : 'AM';
    h = (h > 12)? h -12 : h;
    h = h < 10 ? '0' + h : h;
    m = m < 10 ? '0' + m : m;
    return `${h}:${m} ${s}`;
};